/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_TitleInputs */

const en_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Event`)
};

const fr_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner l'Evenement`)
};

const de_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführungsereignis`)
};

const it_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci evento`)
};

const ru_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие слияния`)
};

const es_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento de fusión`)
};

const zh_cn2_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并事件`)
};

const ja_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マージイベント`)
};

const hi_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलय कार्यक्रम`)
};

const pt_pt2_merge_title = /** @type {(inputs: Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento de Fusão`)
};

/**
* | output |
* | --- |
* | "Merge Event" |
*
* @param {Merge_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_title = /** @type {((inputs?: Merge_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_title(inputs)
	if (locale === "de") return de_merge_title(inputs)
	if (locale === "it") return it_merge_title(inputs)
	if (locale === "ru") return ru_merge_title(inputs)
	if (locale === "es") return es_merge_title(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_title(inputs)
	if (locale === "ja") return ja_merge_title(inputs)
	if (locale === "hi") return hi_merge_title(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_title(inputs)
	return en_merge_title(inputs)
});